"use client";

import { useIsSSR } from "@faire/web/common/server-side-rendering/isSSR";
import React, { Suspense } from "react";

import { isIdentityVerificationModalOrRoute } from "@faire/retailer/components/App/AppModals/utils";
import { useInProductBannersSetup } from "@faire/retailer/hooks/messaging/promoBanner/useInProductBannersSetup";
import { isMobileApp } from "@faire/retailer/lib/isMobileApp";
import { loadable } from "@faire/retailer/lib/loadable";
import { handleComponentLoadError } from "@faire/retailer/lib/loadChunkErrors";
import { usePromoBannerStore } from "@faire/retailer/stores/ui/PromoBannerStore";

export const LazyPromoBanner: React.FC = () => {
  const isSSR = useIsSSR();

  // Trigger the fetch to grab IMP banners
  // it will set values correspondingly inside the promobanner store
  useInProductBannersSetup();

  const { isVisible: isPromoBannerVisible } = usePromoBannerStore([
    "isVisible",
  ]);

  if (
    isSSR ||
    !isPromoBannerVisible ||
    (isMobileApp() && isIdentityVerificationModalOrRoute())
  ) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <LazyPromoBannerBase />
    </Suspense>
  );
};

const LazyPromoBannerBase = loadable(
  () =>
    import(
      /* webpackChunkName: "retailer-promo-banner" */ "./PromoBanner"
    ).catch(handleComponentLoadError),
  { resolveComponent: (m) => m.PromoBanner }
);
